// src/Services/PrivateRoute.tsx
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const PrivateRoute: React.FC = () => {
    const isAuthenticated = !!localStorage.getItem('authToken2');
    return isAuthenticated ? <Outlet /> : <Navigate to="/loginempleados" replace />;
};

export default PrivateRoute;